import { Link, useLocation } from 'react-router-dom';
import Seo from '@/components/Seo';
export default function NotFound() {
 const { pathname } = useLocation();
 return <main className="mx-auto max-w-3xl px-6 py-24">
 <Seo title="Page introuvable | Decennale Artisans" description="Retrouvez les informations sur votre assurance décennale." path={pathname} noindex />
 <p className="font-mono text-accent">404</p><h1 className="font-display text-4xl font-bold my-6">Cette page est introuvable</h1>
 <p className="mb-8">Retrouvez les garanties, les tarifs et les informations adaptées à votre activité.</p>
 <Link className="underline mr-6" to="/">Accueil</Link><Link className="underline" to="/metiers">Tous les métiers</Link>
 </main>;
}
